/**
 * Development Environment
 * Used for dev deployments
 */

export const environment = {
  production: false,
  name: 'development',
  apiBaseUrl: 'https://msuite-llm-de-dev.ambitioussmoke-d4f5c593.centralindia.azurecontainerapps.io',
  
  // ========================================
  // Azure AD B2C Configuration (KEPT FOR FUTURE USE - CURRENTLY NOT ACTIVE)
  // ========================================
  b2c: {
    tenant: 'flatworldsolb2c',
    policy: 'B2C_1_Signin',
    clientId: '8f184213-d574-47f5-acda-283e5200883b',
    authority: 'https://flatworldsolb2c.b2clogin.com/flatworldsolb2c.onmicrosoft.com/B2C_1_Signin',
    knownAuthorities: ['flatworldsolb2c.b2clogin.com'],
    scopes: [
      'openid',
      'offline_access',
      'https://flatworldsolb2c.onmicrosoft.com/llmde/llm.Read'
    ]
  },

  // ========================================
  // Azure AD B2B Configuration (CURRENTLY ACTIVE)
  // ========================================
  b2b: {
    clientId: 'f4204e5b-99bf-4c97-9353-46f82208c89e',
    authority: 'https://login.microsoftonline.com/organizations',
    knownAuthorities: ['login.microsoftonline.com'],
    scopes: ['api://f4204e5b-99bf-4c97-9353-46f82208c89e/access_as_user']
  },

  // URLs for redirect after login/logout - resolved at runtime
  urls: {
    redirectUri: null, // Will be set at runtime
    postLogoutRedirectUri: null // Will be set at runtime
  },

  // App metadata
  app: {
    name: 'Golden Truth Management - Development',
    version: '1.0.0'
  }
};
